import { useState } from 'react';
import { useDebounce } from 'react-use';

export const useDebouncedSearch = (searchTerm: string, delay: number = 500) => {
  const [searchQuery, setSearchQuery] = useState<string | undefined>(searchTerm);

  useDebounce(
    () => {
      if (searchTerm !== searchQuery) {
        setSearchQuery(searchTerm || undefined);
      }
    },
    delay,
    [searchTerm],
  );

  return searchQuery;
};
